import { ActionReducerMap } from '@ngrx/store';

import { CorporateState } from '../constants';
import { reportsReducer } from './reports.reducer';
import { reportStatusReducer } from './status.reducer';
import { companyReducer } from './company.reducer';

export const reducers: ActionReducerMap<CorporateState> = {
  reportStatus: reportStatusReducer,
  reports: reportsReducer,
  company: companyReducer,
};
